import { Table } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { isMobile } from '../../../../../../services/clientService';
import { getTableColumns } from './constants';
import { setSorting } from '../../../../../../reducers/TopAssetManagersReport/actions';

export const TopAssetManagersTable = ({ isLoading, topAssetManagersData }) => {
  const dispatch = useDispatch();

  const { sorting } = useSelector(
    ({ TopAssetManagersReducer }) => TopAssetManagersReducer,
  );
  const handleTableChange = (pagination, filters, sorter) => {
    const { columnKey, order } = sorter;

    dispatch(setSorting({ columnKey, order }));
  };

  const pagination = {
    position: ['bottomRight'],
    defaultPageSize: 50,
  };

  const tableScroll = {
    scrollToFirstRowOnChange: true,
    x: isMobile() ? true : '',
  };

  return (
    <Table
      rowKey="organizationName"
      loading={isLoading}
      columns={getTableColumns({
        sorting: {
          columnKey: sorting.columnKey,
          order: sorting.order,
        },
      })}
      dataSource={topAssetManagersData}
      pagination={pagination}
      scroll={tableScroll}
      onChange={handleTableChange}
    />
  );
};
